import firebase from 'firebase'
import { getQuantity } from '../helpers'

const state = {
  country: null,
  countries: null,
  countriesByContinent: null,
  countriesAmcharts: [],
  errorCountry: null,
  errorByContinent: null
}

const mutations = {
  setCountry (state, payload) {
    state.country = payload
  },
  setCountries (state, payload) {
    state.countries = payload
  },
  setCountriesByContinent (state, payload) {
    state.countriesByContinent = payload
  },
  setCountriesAmcharts (state, payload) {
    state.countriesAmcharts = payload
  },
  setErrorCountry (state, payload) {
    state.errorCountry = payload
  },
  setErrorByContinent (state, payload) {
    state.errorByContinent = payload
  }
}

const actions = {
  fetchCountry ({commit}, payload) {
    firebase.database().ref('countries').orderByChild('code').equalTo(payload.code).once('value')
      .then(snapshot => commit('setCountry', Object.entries(snapshot.val()).map(([key, value]) => ({key, ...value}))[0]))
      .catch(err => commit('setErrorCountry', err.message))
  },
  fetchCountries ({commit}, payload) {
    let promiseCountries = firebase.database().ref('countries')
    if (payload !== undefined) {
      if (payload.codeContinent) {
        promiseCountries = promiseCountries.orderByChild('continent').equalTo(payload.codeContinent.toUpperCase())
      }
    }
    promiseCountries.once('value')
      .then(snapshot => commit('setCountries', Object.entries(snapshot.val()).map(([key, value]) => ({key, ...value}))))
      .catch(err => commit('setErrorCountry', err.message))
  },
  fetchCountriesByContinent ({commit}, payload) {
    firebase.database().ref('countries').orderByChild('continent').equalTo(payload).once('value')
      .then(snapshot => commit('setCountriesByContinent', snapshot.val()))
      .catch(err => commit('setErrorByContinent', err.message))
  },
  fetchCountriesAmcharts ({commit}) {
    let promiseCoins = firebase.database().ref('coins').once('value')
    let promiseBanknotes = firebase.database().ref('banknotes').once('value')
    let promiseCountries = firebase.database().ref('countries').once('value')
    let arr = []

    Promise.all([promiseCoins, promiseCountries, promiseBanknotes]).then(data => {
      let coins = data[0].val()
      let countries = data[1].val()
      let banknotes = data[2].val()
      let arrCoins = Object.entries(coins).map(([key, value]) => ({key, ...value}))
      let arrBanknotes = Object.entries(banknotes).map(([key, value]) => ({key, ...value}))

      for (let i in countries) {
        let coinsByCountry = arrCoins.filter(coin => coin.country === countries[i].code)
        let banknotesByCountry = arrBanknotes.filter(banknote => banknote.country === countries[i].code)
        arr.push({
          'id': countries[i].code,
          'name': countries[i].name,
          'nbCoins': getQuantity(coinsByCountry),
          'nbBanknotes': getQuantity(banknotesByCountry)
        })
      }
      commit('setCountriesAmcharts', arr)
    })
  }
}

const getters = {
  country (state) {
    return state.country
  },
  countries (state) {
    return state.countries
  },
  errorCountry (state) {
    return state.errorCountry
  },
  countriesByContinent (state) {
    return state.countriesByContinent
  },
  countriesAmcharts (state) {
    return state.countriesAmcharts
  },
  errorByContinent (state) {
    return state.errorByContinent
  }
}

export default {
  namespaces: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/country.js